import { useLocation } from "react-router-dom";
import localeText from "../../../../locale";

const ProductQuantity = ({
  productInfo,
  currentVariation,
  currentAttribute1Value,
  currentAttribute2Value,
}) => {
  const locationUrl = useLocation();

  const isFringeBenefitsPage = locationUrl?.pathname?.toLowerCase()?.includes("fringe");

  if (isFringeBenefitsPage) {
    return (
      <div className="text-xs" style={{ color: "#505F79" }}>
        {localeText("availableStock")} {"("}
        {productInfo.data.product.amountInStock}
        {")"}
      </div>
    );
  }

  return (
    <>
      {!productInfo.data.product.downloadable && (
        <div className="text-xs" style={{ color: "#505F79" }}>
          {currentVariation &&
          ((productInfo.data.attributes.length === 2 &&
            currentAttribute1Value &&
            currentAttribute2Value) ||
            (productInfo.data.attributes.length === 1 && currentAttribute1Value)) ? (
            <>
              {localeText("availableStock")} {"("}
              {currentVariation.amountInStock}
              {")"}
            </>
          ) : (
            <>
              {productInfo?.data?.productVariations?.length === 0 && (
                <>
                  {localeText("availableStock")} {"("}
                  {productInfo.data.product.amountInStock}
                  {")"}
                </>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default ProductQuantity;
